/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
  useBlockProps,
  InspectorControls,
  PanelColorSettings
} from "@wordpress/block-editor";
import {
  PanelBody,
  TextControl,
  RangeControl
} from "@wordpress/components";
import { Fragment } from "@wordpress/element";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */

export default function Edit({ attributes, setAttributes }) {
  const {
    readTimePrefix = '',
    textColor, fontSize , readTimeSuffix
  } = attributes;
  const style = {
    fontSize: `${fontSize}px`,
    color: textColor,
  };
  return (
    <div {...useBlockProps()}>
    <Fragment>
      <InspectorControls>
        <PanelBody
          title={__('Read Time Settings', 'templazee')}
          initialOpen={true}
        >
          <TextControl
            label={__('Prefix Text', 'templazee')}
            value={readTimePrefix}
            onChange={(newValue) => {
              setAttributes({
                readTimePrefix: newValue
              });
            }}
            placeholder={__('Enter prefix text...', 'templazee')}
          />

          <TextControl
            label={__('Suffix Text', 'templazee')}
            value={readTimeSuffix}
            onChange={(newValue) => {
              setAttributes({
                readTimeSuffix: newValue
              });
            }}
            placeholder={__('Enter suffix text...', 'templazee')}
          />

           <RangeControl
            label={__("Font Size", "templazee")}
            value={fontSize}
            onChange={(newSize) => setAttributes({ fontSize: newSize })}
            min={10}
            max={100}
          />

          <PanelColorSettings
          title={__("Color Settings", "templazee")}
            colorSettings={[
              {
                label: __("Text Color", "templazee"),
                value: textColor,
                onChange: (newColor) =>
                  setAttributes({ textColor: newColor }),
              }
            ]}
            initialOpen={false}
          />
        </PanelBody>
      </InspectorControls>

        <div className="read-time-block-preview" style={style}>
          {readTimePrefix || ''} 1 {readTimeSuffix || ''}
        </div>

    </Fragment>
    </div>
  );
}
